import axios from 'axios';
import { baseUrl_SPB } from '../BaseUrl';

const DeleteBookedItemRoster = async (bookedItem,token) => {

    try {
        console.log('bookedItem', bookedItem);
        console.log('token', token);
        return new Promise((resolve, reject) => {

        const response= axios.post(`${baseUrl_SPB}/api/v1/rostertimeallocation/delete`, bookedItem, {
            headers: {
                
                'Authorization': 'Bearer ' + token
            },
        }
        )
         .then(data => {
            
                return resolve(data);
            })
            .catch(error => {
                return reject('failed to add ',error);
            });
        });
      
       
    } catch (error) {
        console.error('Error updating user:', error);
        return null;
    }
}


export default DeleteBookedItemRoster;;